import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// core styles
import "./scss/ag-app.scss";

// vendor styles
import "react-datetime/css/react-datetime.css";

import Main from "./pages/Main";
import ErrorBoundary from "./components/ErrorBoundary";

const container = document.getElementById("root");
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </ErrorBoundary>
);
